import { takeEvery, call, put, all } from 'redux-saga/effects';

import EntitlementActions from './entitlement-actions';
import EntitlementApi from './entitlement-api';

function* fetchEntitlementsHandler({ payload: { experienceId, promotionId } }) {
  const _entitlements = yield call(EntitlementApi.fetchEntitlements, experienceId, promotionId);
  if (_entitlements.error) yield put(EntitlementActions.fetchEntitlementsFailure(_entitlements.error));
  else yield put(EntitlementActions.fetchEntitlementsSuccess(experienceId, promotionId, _entitlements));
}

export default function* entitlementSaga() {
  yield all([takeEvery(EntitlementActions.fetchEntitlements.getType(), fetchEntitlementsHandler)]);
}
